import React from "react";
import renderErrors from "../validations/renderErrors";
import LoadingIcon from "../icons/loadingIcon";

const UploadForm = ({
  closeModal,
  description,
  errors,
  handleAddLocation,
  handleSubmit,
  image,
  label,
  loading,
  locationError,
  onChangeDescription,
  onChangeImage,
  setErrors,
  setPreviewMessage,
}) => (
  <>
    <div className="upload-modal">
      <div className="desktop-header">
        <button className="close-btn" onClick={closeModal}>
          X
        </button>
        <h2>Share a photo</h2>
      </div>
      <div className="api-error">{errors && renderErrors(errors)}</div>
      {!locationError ? (
        <form
          onChange={() => {
            setErrors({});
          }}
          onSubmit={handleSubmit}
        >
          <div className="input-container">
            <label className="file-input">
              {label}
              <input
                type="file"
                name="image"
                value={image}
                onChange={onChangeImage}
                required
                accept="image/jpg, image/jpeg, image/png"
              />
            </label>
          </div>
          <div className="input-container">
            <textarea
              cols={1}
              rows={6}
              maxLength={280}
              wrap="hard"
              name="description"
              placeholder="please provide a description of the sighting"
              className="input-field"
              id="input-field"
              value={description}
              onChange={onChangeDescription}
              required
            />
          </div>
          {image && (
            <div>
              <button
                className="auth-btn"
                onClick={() => {
                  setPreviewMessage(false);
                }}
              >
                Upload
              </button>
            </div>
          )}
        </form>
      ) : (
        <div>
          <button
            className="auth-btn"
            id="auth-btn"
            onClick={handleAddLocation}
          >
            Add Location
          </button>
        </div>
      )}
    </div>
    {loading && <LoadingIcon type={"spokes"} />}
  </>
);

export default UploadForm;
